(function ($) {
  //
  // This function will perform AJAX call to server to confirm if the quoting has
  // completed. Depending on the quoting status, it will:
  //
  // * If status is "queued" ->
  //     will schedule next check for the server
  // * If status either "completed" or "failed" ->
  //     will submit the form to allow journey transition to next stage
  // * If AJAX fails ->
  //     will submit the form to allow journey handle the valid step resolution
  //
  // The Worker's Comp carousel will check as each new image is displayed (every 6 secs)
  // The general carousel will check every 13 secs
  //
  var formSubmitted = false;

  function handleWaitingForQuotesPage() {
    var $form = $(".js-waiting-for-quotes form");
    var timeoutRef, waitTime = 2000;
    var waitForQuotePageVariant = document.querySelector(".js-waiting-for-quotes").dataset.waitForQuotePageVariant
    if (waitForQuotePageVariant == "carousel_general") {
      bindCarouselListener(3, "quote", 5000);
      waitTime = 13000;
    } else if (waitForQuotePageVariant == "carousel_wc") {
      bindCarouselListener(10, "wc", 6000);
      waitTime = 6000;
    } else if (waitForQuotePageVariant == "carousel_bop") {
      bindCarouselListener(5, "bop", 6000);
      waitTime = 13000;
    }
    $.ajax({
      type: "POST",
      url: location.pathname + "?step_action=check_quote_status",
      dataType: "json"
    }).done(function (data) {
      switch (data.status) {
        case "queued":
          timeoutRef = setTimeout(handleWaitingForQuotesPage, waitTime);
          break;
        case "completed":
        case "failed":
        default:
          clearTimeout(timeoutRef);
          if (!formSubmitted) {
            formSubmitted = true;
            $form.submit();
          }
          break;
      }
    }).fail(function () {
      clearTimeout(timeoutRef);
      // if polling fails, process current step and let the journey handle it this
      // will prevent the user from getting stuck in the waiting for quotes page
      if (!formSubmitted) {
        formSubmitted = true;
        $form.submit();
      }
    });
  }

  var intervalId;
  var counter = 0;

  function bindCarouselListener(numImages, classPrefix, timeout) {
    var waitForQuotePageVariant = document.querySelector(".js-waiting-for-quotes").dataset.waitForQuotePageVariant;

    // Clear the previous interval
    if (intervalId) {
      clearInterval(intervalId);
    }

    if (document.readyState !== 'loading') {
      intervalId = carouselLogic(numImages, classPrefix, timeout, waitForQuotePageVariant);
    } else {
      window.addEventListener("DOMContentLoaded", function () {
        intervalId = carouselLogic(numImages, classPrefix, timeout, waitForQuotePageVariant);
      });
    }
  }

  function carouselLogic(numImages, classPrefix, timeout, waitForQuotePageVariant) {
    return setInterval(function () {
      counter += 1;
      const imageNumber = (counter % numImages) + 1;
      if ((waitForQuotePageVariant == "carousel_general" && imageNumber == 3) ||
        (waitForQuotePageVariant == "carousel_wc" && imageNumber == 2)) {
        showTrustpilotWidget();
      } else {
        hideTrustpilotWidget();
        document.querySelector(
          "#txt-id"
        ).className = `${classPrefix}-wait-txt-${imageNumber}`;
      }
      document.querySelector(
        "#img-id"
      ).className = `${classPrefix}-wait-img-${imageNumber}`;
    }, timeout);
  }

  function showTrustpilotWidget() {
    document.querySelector(
      ".trustpilot-widget-carousel"
    ).classList.remove("hidden"),
      document.querySelector(
        "#txt-id"
      ).classList.add("hidden")
  }

  function hideTrustpilotWidget() {
    document.querySelector(
      ".trustpilot-widget-carousel"
    ).classList.add("hidden")
  }

  $(document).ready(function () {
    if ($(".js-waiting-for-quotes").length > 0) {
      handleWaitingForQuotesPage();
    }
  });

  //  ------------------------------------------------
  // Using carouselV2
  function checkQuoteStatus() {
    const $form = $('.waiting-for-quotes-form');
    let timeoutRef;
    const checkTime = 2000;

    $.ajax({
      type: "POST",
      url: location.pathname + "?step_action=check_quote_status",
      dataType: "json"
    }).done(function (data) {
      switch (data.status) {
        case "queued":
          timeoutRef = setTimeout(checkQuoteStatus, checkTime);
          break;
        case "completed":
        case "failed":
        default:
          clearTimeout(timeoutRef);
          if (!formSubmitted) {
            formSubmitted = true;
            $form.submit();
          }
          break;
      }
    }).fail(function () {
      clearTimeout(timeoutRef);
      // if polling fails, process current step and let the journey handle it this
      // will prevent the user from getting stuck in the waiting for quotes page
      if (!formSubmitted) {
        formSubmitted = true;
        $form.submit();
      }
    });
  }

  // Check the quote status once the carousel has finished "loading"
  let form = document.querySelector(".waiting-for-quotes-form");
  if (!!form) {
    const delay = form.dataset.nextStepDelay;
    setTimeout(checkQuoteStatus, delay);
  }
})(window.jQuery);
